var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDown = function SvgDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.585 5.15 7.759 9.615a1 1 0 0 1-1.518 0L2.415 5.151a1 1 0 0 1 .76-1.651h7.65a1 1 0 0 1 .76 1.65Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDown);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjU4NSA1LjE1MDc5TDcuNzU5MjYgOS42MTQyQzcuMzYwMTYgMTAuMDc5OCA2LjYzOTg0IDEwLjA3OTggNi4yNDA3NCA5LjYxNDJMMi40MTQ5NyA1LjE1MDc5QzEuODU4OTYgNC41MDIxMiAyLjMxOTg3IDMuNSAzLjE3NDIyIDMuNUwxMC44MjU4IDMuNUMxMS42ODAxIDMuNSAxMi4xNDEgNC41MDIxMiAxMS41ODUgNS4xNTA3OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KPC9zdmc+Cg==";